import { useState } from "react";
import PixelBlast from "@/components/PixelBlast";
import { QRPopup } from "@/utils/app-download-button";
import { NovaHero } from "./sections/nova-hero";
import { NovaFeaturedOffer } from "./sections/nova-featured-offer";
import { NovaPerks } from "./sections/nova-perks";
import { NovaPartnerCarousel } from "./sections/nova-partner-carousel";
import { NovaHowItWorks } from "./sections/nova-how-it-works";
import { NovaCTA } from "./sections/nova-cta";

export function Nova() {
  const [showQR, setShowQR] = useState(false);

  return (
    <div className="page-root">
      <div className="absolute inset-0 z-0 opacity-20 pointer-events-none">
        <PixelBlast
          variant="circle"
          pixelSize={5}
          color="#00d9d9"
          patternScale={5}
          patternDensity={1.2}
          pixelSizeJitter={0}
          enableRipples
          rippleSpeed={0.4}
          rippleThickness={0.22}
          rippleIntensityScale={3}
          liquid={false}
          liquidStrength={0.12}
          liquidRadius={1.2}
          liquidWobbleSpeed={5}
          speed={0.5}
          edgeFade={0.25}
          transparent
        />
      </div>

      <div className="relative z-10">
        <NovaHero showQR={showQR} setShowQR={setShowQR} />
        <NovaFeaturedOffer />
        <NovaPerks />
        <NovaPartnerCarousel />
        <NovaHowItWorks />
        <NovaCTA setShowQR={setShowQR} />
      </div>

      {showQR && <QRPopup onClose={() => setShowQR(false)} />}
    </div>
  );
}
